'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var sort = exports.sort = 140;

var config = exports.config = function config() {
	return {
		label: 'CSS Class',
		props: [{
			name: 'class',
			inputType: 'text',
			label: 'CSS class',
			default: ''
		}]
	};
};